import React from "react";
import Header from "../components/Header";
import { FiArrowUpRight } from "react-icons/fi";

export default function Inspiration() {
  return (
    <div className="container">
      <Header />
      <h3 className="text-white mt-5">Documentaries</h3>
      <div className="my-1 d-flex flex-column">
        <a
          href="https://www.youtube.com/watch?v=WXuK6gekU1Y&ab_channel=GoogleDeepMind"
          target="_blank"
          rel="noreferrer"
          className="mt-2"
        >
          <FiArrowUpRight size={20} className="me-2" />
          Alphago
        </a>

        <div>
          <a
            href="https://www.youtube.com/watch?v=px-O6clHbK0&ab_channel=MisterArdor"
            target="_blank"
            rel="noreferrer"
            className="mt-4"
          >
            <FiArrowUpRight size={20} className="me-2" />
            For Honor Game Documentary
          </a>
        </div>
      </div>
    </div>
  );
}
